import { render, staticRenderFns } from "./commonSettingNotice.vue?vue&type=template&id=3626fede&scoped=true"
import script from "./commonSettingNotice.vue?vue&type=script&lang=js"
export * from "./commonSettingNotice.vue?vue&type=script&lang=js"
import style0 from "./commonSettingNotice.vue?vue&type=style&index=0&id=3626fede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626fede",
  null
  
)

export default component.exports